module.exports = __webpack_public_path__ + "static/media/teygja_axlir.09c5a880.png";